import {Shape} from './index.js';

export class Polygon extends Shape {
	constructor({ x, y, sides, radius, fill = 'black', stroke = [1, 'black'] }) {
		super({ x, y, fill, stroke });
		this.sides = sides;
		this.radius = radius;
	}

	draw(context) {
		if (this.sides < 3) return;
		context.save();
		context.beginPath();
		for (let i = 0; i < this.sides; i++) {
			const angle = (Math.PI * 2 / this.sides) * i;
			const px = this.position.x + this.radius * Math.cos(angle);
			const py = this.position.y + this.radius * Math.sin(angle);
			i === 0 ? context.moveTo(px, py) : context.lineTo(px, py);
		}
		context.closePath();
		this.applyStyles(context);
		context.fill();
		context.stroke();
		this.beforeRestore(context)
		context.restore();
	}
}
